var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meeting-list-page" }, [
    _c(
      "div",
      { staticClass: "meeting-filter-wrap" },
      [
        _c("meeting-list-filter", {
          on: {
            "clear-filter": function($event) {
              return _vm.clearFilter()
            }
          },
          model: {
            value: _vm.filter,
            callback: function($$v) {
              _vm.filter = $$v
            },
            expression: "filter"
          }
        })
      ],
      1
    ),
    _vm.isReady
      ? _c(
          "div",
          {
            staticClass:
              "meeting-list-content portal-compact-list-shell show-scrollbar"
          },
          [
            _c("v-data-table", {
              key: _vm.tableKey,
              staticClass: "portal-compact-table",
              staticStyle: { cursor: "pointer" },
              attrs: {
                headers: _vm.headers,
                items: _vm.filteredMeetingList,
                "items-per-page": 10,
                "mobile-breakpoint": 200,
                "sort-by": "confirmedTime.start",
                "sort-asc": "",
                "hide-default-footer": _vm.scheduledMeetings.length <= 10
              },
              on: {
                "click:row": function($event) {
                  return _vm.openScheduledMeeting($event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.confirmedTime.start",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              "portal-cell-truncate",
                              "portal-cell-muted",
                              item.meetingStatus === "Cancelled"
                                ? "cancelled"
                                : ""
                            ],
                            attrs: {
                              title: _vm.DateTime.fromISO(
                                item.confirmedTime.start
                              ).toLocaleString(
                                _vm.DateTime.DATETIME_MED_WITH_WEEKDAY
                              )
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.confirmedTime.start
                                  ).toLocaleString({
                                    month: "short",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit"
                                  })
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.meetingName",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              "portal-cell-truncate",
                              "portal-cell-primary",
                              item.meetingStatus === "Cancelled"
                                ? "cancelled"
                                : ""
                            ],
                            attrs: { title: item.meetingName }
                          },
                          [_vm._v(" " + _vm._s(item.meetingName) + " ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.contact",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              "portal-cell-truncate",
                              item.meetingStatus === "Cancelled"
                                ? "cancelled"
                                : ""
                            ],
                            attrs: {
                              title:
                                item.formData.firstName +
                                " " +
                                item.formData.lastName
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.formData.firstName) +
                                " " +
                                _vm._s(item.formData.lastName)
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "no-data",
                    fn: function() {
                      return [
                        !_vm.scheduledMeetings.length
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("meetings.booked.no-meetings-booked")
                                  ) +
                                  " "
                              )
                            ])
                          : _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "meetings.booked.no-matching-criteria"
                                    )
                                  ) +
                                  " "
                              )
                            ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                5616105
              )
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }